module.exports = __webpack_public_path__ + "static/img/mobile.0b98d67.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/IsraelToday/mobile.png
// module id = 2aMj
// module chunks = 0